$(document).ready(function(){
  if($( window ).width()>800){
    $("body").on('mouseover',".main_li",function(){
      $(this).addClass("hover");
    });

    $("body").on('mouseout',".main_li",function(){
      $(this).removeClass("hover");
    });
  }
  if($( window ).width()<800){
    $(".sub_nav").hide();
    $(".dog_link").removeAttr("href");
    $(".cat_link").removeAttr("href");
    $(".filter-group").find("ul").hide();
    /*$(".nav-bar").find("#customer_register_link").removeAttr("href").click(function(){
    	$(".sweettooth-cta span").click();
    });*/
    
    
    $('.mobile_plus').on('click', function() {
      
      if( $(this).hasClass('collapsed') ){
        $(this).removeClass('collapsed').addClass('expanded').closest('.main_li').toggleClass('active').find('.sub_nav').fadeToggle();
      } else {
        $(this).removeClass('expanded').addClass('collapsed').closest('.main_li').toggleClass('active').find('.sub_nav').fadeToggle();
      }
      
    });
    
    $('.plus_sign').on('click', function() {
      
      if( $(this).hasClass('collapsed') ) {        
        $(this).removeClass('collapsed').addClass('expanded').closest('.sub_li').find('.sub_sub_nav').slideToggle();
      } else {
        $(this).removeClass('expanded').addClass('collapsed').closest('.sub_li').find('.sub_sub_nav').slideToggle();
      }
      
    });
    
    $('.dog_plus_sign').on('click', function(){
      if( $(this).hasClass('collapsed') ) {
        $(this).removeClass('collapsed').addClass('expanded').closest('.sub_nav').find('.dog_nav').slideToggle();
      } else {
        $(this).removeClass('expanded').addClass('collapsed').closest('.sub_nav').find('.dog_nav').slideToggle();
      }
      
    });
    
    $('.cat_plus_sign').on('click', function(){
      if( $(this).hasClass('collapsed') ) {
        $(this).removeClass('collapsed').addClass('expanded').closest('.sub_nav').find('.cat_nav').slideToggle();
      } else {
        $(this).removeClass('expanded').addClass('collapsed').closest('.sub_nav').find('.cat_nav').slideToggle();
      }
      
    });
    
  }
//   $(".notification_bar").text("Operating Hours: Monday - Friday, 9AM - 6PM (Excluding PH) 📱: +65 6206 5165");
//   setInterval(function(){ 
//     switch($(".notification_bar").attr("attr")) {
//         case "1":
//             $(".notification_bar").text("FREE DELIVERY when your pawrent orders above $25! 🛒");
//       		$(".notification_bar").attr("attr","2");
//             break;
//         /*case "2":
//             $(".notification_bar").text(" We're unable to deliver on Labour Day, we will be back to serve you on 02 May 2017! Wufff 💕");
//       		$(".notification_bar").attr("attr","3");
//             break;*/
//         /* $(".notification_bar").text("Operating Hours: Monday - Friday, 9AM - 6PM (Excluding PH) 📱: +65 6206 5165");
//   setInterval(function(){ 
//     switch($(".notification_bar").attr("attr")) {
//         case "1":
//             $(".notification_bar").text("FREE DELIVERY when your pawrent orders above $25! 🛒");
//       		$(".notification_bar").attr("attr","2");
//             break; */      
        
//         default:
//             $(".notification_bar").text("PetCurean & Organix Hot Deals! Only $29.9 😺 📱: +65 6206 5165");
//       		$(".notification_bar").attr("attr","1");
//     } 
//   }, 5000);
  
  
  var total_notification = $('.notification_bar .notifications').prop('childElementCount');

  var current_notification = 1;
  setInterval(function() { 
    $(".notification_bar .notifications li").hide();
    $(".notification_bar .notifications li:nth-child("+ current_notification +")").show();
    
    if (current_notification < total_notification){
      current_notification += 1;
    }else{
      current_notification = 1;
    }
  }, 10000);
  
  //hide the home page 5th item in mobile
  if($(location).attr("href")=="https://www.perromart.com/" && $( window ).width()<800){
    $(".grid-uniform").each(function(){
    	$(this).find(".grid-item").last().css( "display", "none" );
    });
  }
  
  $('#collectionFilters').find('h4').each(function() {
    $(this).on('click', function() {
      $(this).closest('.filter-group').find('ul').slideToggle();
      $(this).find('.chevron').toggleClass('toggle');
    });
  });
  
});